"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setScene7UrlQueryParams = void 0;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var addProtocol = function addProtocol(url) {
  return url.startsWith('//') ? "https:".concat(url) : url;
};
var stripPresets = function stripPresets(url) {
  var presets = url.match(/(\$(.[^$]+)\$)/g) || [];
  return presets.reduce(function (reducedUrl, preset) {
    return reducedUrl.replace(preset, '');
  }, url);
};
var stripSrcParam = function stripSrcParam() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var srcParams = url.match(/(src=ir\(.+\))/g) || [];
  return [srcParams.length === 0 ? url : url.replace(srcParams[0], ''), srcParams[0]];
};
var getQueryPrefix = function getQueryPrefix(url) {
  if (!url.includes('?')) {
    return '?';
  } else if (url.endsWith('&')) {
    return '';
  } else return '&';
};
var setScene7UrlQueryParams = exports.setScene7UrlQueryParams = function setScene7UrlQueryParams() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _stripSrcParam = stripSrcParam(stripPresets(url)),
    _stripSrcParam2 = _slicedToArray(_stripSrcParam, 2),
    strippedUrl = _stripSrcParam2[0],
    srcParam = _stripSrcParam2[1];
  var urlObj;
  try {
    urlObj = new URL(addProtocol(strippedUrl));
  } catch (e) {
    return "".concat(url).concat(getQueryPrefix(url)).concat(Object.entries(queryParams).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        val = _ref2[1];
      return "".concat(key, "=").concat(val);
    }).join('&'));
  }
  Object.entries(queryParams).forEach(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      val = _ref4[1];
    urlObj.searchParams.set(key, val);
  });
  var urlString = srcParam ? urlObj.toString().replace("?", "?".concat(srcParam, "&")) : urlObj.toString();
  return urlString.substring(urlString.indexOf('//'));
};